import { createContext, useContext, useState, useCallback } from "react";
import { InviteDialog } from "@/components/InviteDialog";

const InviteCtx = createContext({ openInvite: () => {} });

export function useInvite() { return useContext(InviteCtx); }

export function InviteProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [onChanged, setOnChanged] = useState(null);
  const openInvite = useCallback((opts = {}) => {
    setOnChanged(() => opts.onChanged || null);
    setOpen(true);
  }, []);
  return (
    <InviteCtx.Provider value={{ openInvite }}>
      {children}
      <InviteDialog open={open} onClose={() => setOpen(false)} onChanged={onChanged || undefined} />
    </InviteCtx.Provider>
  );
}
